/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 06.06.2016.
 */

lmApp.service('SubscriberRsc', ['$resource', function ($resource) {

  return $resource('/discovery:80/v2/sotalcloud-authentication/2/accounts/:accountId/:action',
    null,
    {
      query: {
        method: 'GET',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        },
        interceptor: {
          response: function(response) {
            return response.data.accounts;
          }
        }
      },
      take: {
        method: 'GET',
        params: {
          accountId : '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        url: '/discovery:80/sdp/v2/subscribers/:subscriberId',
        method: 'PATCH',
        params: {
          subscriberId : '@id'
        },
        transformRequest: function (data) {
          return JSON.stringify({
            "first_name": data.first_name,
            "last_name": data.last_name,
            "username": data.username,
            "address_country": data.address.country,
            "address_city": data.address.city
          });
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      setPass: {
        method: 'PUT',
        params: {
          action: 'password',
          accountId : '@id'
        },
        isArray: false,
        transformRequest: function (data) {
          return data.password;
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      resetPass: {
        url: '/discovery:80/v2/sotalcloud-authentication/2/password-reset-requests',
        method: 'POST',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      setPin: {
        url: '/discovery:80/sdp/v2/subscribers/:subscriberId',
        method: 'PATCH',
        params: {
          subscriberId : '@id'
        },
        transformRequest: function (data) {
          return JSON.stringify({
                    "pc_pin": data.pc_pin,
                });
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      }
    });
}]);
